export type EnergySector =
  | 'residential'
  | 'commercial'
  | 'industrial'
  | 'agricultural'
  | 'institutional'
  | 'other_nonresidential'
  | 'nonresidential'
  | 'total';

export type CoverageStatus =
  | 'complete_observed'
  | 'partial_observed_lower_bound'
  | 'cap_published'
  | 'cap_derived_total'
  | 'estimated_complete'
  | 'interpolated'
  | 'extrapolated';

export type SourceClass = 'utility_observed' | 'cap_published' | 'cap_derived' | 'modeled' | 'hybrid';

export type ExperimentFuel = 'electricity' | 'natural_gas';

export interface ActivityEstimate {
  value: number | null;
  lowerBound?: number | null;
  upperBound?: number | null;
  unit: 'kWh' | 'therms';
  coverage: CoverageStatus;
  sourceClass: SourceClass;
  includedCategories: string[];
  missingCategories: string[];
  methodId: string;
  sourceNote: string;
  /** Gas nonresidential: modeled additional/unallocated component (not industrial claim). */
  additionalNonresidentialComponent?: number | null;
  commercialComponent?: number | null;
  industrialComponent?: number | null;
  proportionalAllocationSensitivity?: number | null;
}

export interface ReconciliationResult {
  residentialPlusNonresidential: number | null;
  controlTotal: number | null;
  delta: number | null;
  passes: boolean;
  note: string;
}

export interface CanonicalEnergyActivityYear {
  geoid: string;
  year: number;
  fuel: ExperimentFuel;
  residential: ActivityEstimate;
  commercial: ActivityEstimate;
  industrial: ActivityEstimate;
  agricultural: ActivityEstimate;
  otherNonresidential: ActivityEstimate;
  nonresidential: ActivityEstimate;
  total: ActivityEstimate;
  reconciliation?: ReconciliationResult;
  legacyPhysicalResidential?: number | null;
  legacyPhysicalCommercial?: number | null;
  legacyGhgResidential?: number | null;
  legacyGhgCommercial?: number | null;
  /** Burbank pilot: pure EIA-861 BWP kWh for dotted overlay when the bar uses published CAP. */
  eia861ReferenceResidentialKwh?: number | null;
  eia861ReferenceNonresidentialKwh?: number | null;
  /** Beverly Hills gas experiment: no separate industrial/unallocated component. */
  gasAssumptionId?: string;
}

export const BH_CAP_NONRESIDENTIAL_EXPERIMENT_V2_POLICY = 'bh_cap_nonresidential_experiment_v2';
export const BURBANK_EIA861_PILOT_POLICY = 'burbank_eia861_pilot_v1';
